function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.69997 11.26C3.39583 11.26 3.95993 10.6959 3.95993 10C3.95993 9.30415 3.39583 8.74005 2.69997 8.74005L2.69997 11.26ZM1.10908 9.10908C0.617037 9.60112 0.617037 10.3989 1.10908 10.8909L9.12737 18.9092C9.61941 19.4012 10.4172 19.4012 10.9092 18.9092C11.4013 18.4172 11.4013 17.6194 10.9092 17.1274L3.78184 10L10.9092 2.87263C11.4012 2.38059 11.4012 1.58283 10.9092 1.09079C10.4172 0.59875 9.61941 0.59875 9.12737 1.09079L1.10908 9.10908ZM2.69997 8.74005L2 8.74005L2 11.26L2.69997 11.26L2.69997 8.74005Z",
  fill: "white"
});

function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.78c64cca.svg";
export { ForwardRef as ReactComponent };